import { render, staticRenderFns } from "./FfUserGroupSelector.vue?vue&type=template&id=dc92df7e&scoped=true&"
import script from "./FfUserGroupSelector.vue?vue&type=script&lang=ts&"
export * from "./FfUserGroupSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FfUserGroupSelector.vue?vue&type=style&index=0&id=dc92df7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc92df7e",
  null
  
)

export default component.exports